package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class BulkActionResponse(
    val results: List<BulkActionItemResult>,
)

@Serializable
data class BulkActionItemResult(
    val id: String,
    val success: Boolean,
    val error: String? = null,
)
